<template>
  <div>
    <div
      ref="drop_zone"
      class="ts-p-3 ts-border ts-rounded ts-border-dashed overflow-auto drop_zone"
      :class="{
        'ts-bg-blue-300': is_drag_over
      }"
      v-cloak
      @dragover.prevent="() => (is_drag_over = true)"
      @dragleave.prevent="() => (is_drag_over = false)"
      @drop.prevent="dropFile"
      @dblclick="$refs.input_file.click()"
    >
      <span class="ts-text-xs" v-if="files.length == 0">{{ placeholder }}</span>
      <template v-for="(file, index) in files">
        <view-file
          :key="index"
          :item="file"
          :file-index="index"
          @remove="removeFrontSide"
        />
      </template>
    </div>
    <input
      type="file"
      ref="input_file"
      @change="onFileChange"
      style="display:none"
    />
  </div>
</template>

<script>
import ViewFile from './view-file'
import httpClient from '@/http-client'

export default {
  name: 'dropFile',
  props: ['placeholder', 'fileLink'],
  components: {
    ViewFile
  },
  data() {
    return {
      is_drag_over: false,
      files: []
    }
  },
  created() {
    if (this.fileLink) {
      this.files = [
        {
          name: 'unknow',
          size: 0,
          type: 'image/png',
          progressing: 0,
          invalid_file: false,
          file: null,
          uploaded: true,
          storage_path: this.fileLink
        }
      ]
    }
  },
  methods: {
    dropFile(e) {
      let droppedFiles = e.dataTransfer.files

      if (!droppedFiles || this.validate(...droppedFiles)) {
        this.is_drag_over = false
        return
      }
      this.files = [
        ..._.map(droppedFiles, file => ({
          name: file.name,
          size: parseInt(file.size / 1024),
          type: file.type,
          progressing: 0,
          invalid_file: this.validate(file),
          file: file,
          uploaded: false,
          storage_path: null
        }))
      ]
      this.is_drag_over = false

      this.uploadFile()
    },
    onFileChange(e) {
      let files = e.target.files

      if (!files || this.validate(...files)) {
        this.is_drag_over_front = false
        return
      }
      this.files = [
        ..._.map(files, file => ({
          name: file.name,
          size: parseInt(file.size / 1024),
          type: file.type,
          progressing: 0,
          invalid_file: this.validate(file),
          file: file,
          uploaded: false,
          storage_path: null
        }))
      ]
      this.uploadFile()
    },
    validate(file) {
      let ALLOW_FILE = ['image/png', 'image/jpeg']

      if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
        return true
      }

      return false
    },
    uploadFile() {
      _.forEach(
        this.files.filter(file => file.uploaded == false),
        (f, index) => {
          if (!this.validate(f.file)) {
            let frm = new FormData()
            frm.append('file', f.file)
            frm.append('upload_as', 'thumbnail')
            httpClient
              .post('/api/content-managements/upload-files', frm, {
                onUploadProgress: el => {
                  if (el.lengthComputable) {
                    f.progressing = Math.round((el.loaded * 100) / el.total)
                  }
                }
              })
              .then(response => {
                f.uploaded = true
                f.storage_path = response.data
                this.$emit('file', this.files[0].storage_path)
              })
              .catch(error => {
                this.$toasted.error(error.message)
                this.files = []
              })
          }
        }
      )
    },
    removeFrontSide({ index, record }) {
      this.files.splice(index, 1)
      this.$emit('file', null)
    }
  },
  watch: {
    fileLink: function(value) {
      if (value) {
        this.files = [
          {
            name: 'unknow',
            size: 0,
            type: 'image/png',
            progressing: 0,
            invalid_file: false,
            file: null,
            uploaded: true,
            storage_path: value
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.drop_zone {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
